import Vue from 'vue'
import VueRouter from 'vue-router'
import Mixer from '../views/Mixer.vue'
import Admin from '../views/Admin.vue'
import Edit from '../views/Edit.vue'
import Add from '../views/Add.vue'
import Login from '../views/Login.vue'
import Register from '../views/Register.vue'
import Reset from '../views/Reset.vue'
import Account from '../views/Account.vue'

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Mixer',
    component: Mixer
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/register',
    name: 'Register',
    component: Register
  },
  {
    path: '/reset',
    name: 'Reset',
    component: Reset
  },
  {
    path: '/account',
    name: 'Account',
    component: Account,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/admin',
    name: 'Admin',
    component: Admin,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/admin/edit',
    name: 'Edit',
    component: Edit,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/admin/add',
    name: 'Add',
    component: Add,
    props: true,
    meta: {
      requiresAuth: true
    }
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
